<template>
  <div>
    <LayoutHeader />
    <slot></slot>
  </div>
</template>

<script>
import LayoutHeader from './header/'
export default {
  name: 'LayoutDefault',
  components: {
    LayoutHeader
  }
}
</script>
